export function transformExpression(input) {
  let index = 0
  const result = []

  function removeParentheses(text) {
    return text.replace(/[()]/g, '')
  }

  const cleanedInput = removeParentheses(input)

  function splitByTopLevelAND(expr) {
    const parts = []
    let bracketCount = 0
    let start = 0

    for (let i = 0; i < expr.length; i++) {
      if (expr[i] === '(') bracketCount += bracketCount
      else if (expr[i] === ')') bracketCount -= bracketCount

      if (bracketCount === 0 && expr.slice(i, i + 5) === ' AND ') {
        parts.push(expr.slice(start, i).trim())
        start = i + 5
        i += 4
      }
    }

    parts.push(expr.slice(start).trim())
    return parts
  }

  function highlightOR(expr) {
    return expr.replace(/\bOR\b/g, '<span class="or-divider">OR</span>')
  }

  const expressions = splitByTopLevelAND(cleanedInput)

  for (const exp of expressions) {
    const highlighted = highlightOR(exp)
    result.push(
      `<div class="line">
        <span class="number">
            ${ index += 1 }
        </span>
        <span class="content">
            + ${ highlighted }
        </span>
      </div>`
    )
  }

  return result.join('\n')
}

export function transformSimilarResults(input) {
  if (!input) return ''

  const result = []
  const expressions = []

  function removeParentheses(text) {
    return text.replace(/[()]/g, '')
  }

  const cleanedInput = removeParentheses(input)

  function splitByTopLevelAND(expr) {
    const parts = []
    let bracketCount = 0
    let start = 0

    for (let i = 0; i < expr.length; i++) {
      if (expr[i] === '(') bracketCount += 1
      else if (expr[i] === ')') bracketCount -= 1

      if (bracketCount === 0 && expr.slice(i, i + 5) === ' AND ') {
        parts.push(expr.slice(start, i).trim())
        start = i + 5
        i += 4
      }
    }

    parts.push(expr.slice(start).trim())
    return parts
  }

  function highlightOR(expr) {
    return expr.replace(/\bOR\b/g, '<span class="or-divider">OR</span>')
  }

  const expressionParts = splitByTopLevelAND(cleanedInput)

  for (const exp of expressionParts) {
    expressions.push(exp)
    const highlighted = highlightOR(exp)
    result.push(
      `<div class="line">
        <span class="content">
            + ${ highlighted }
        </span>
      </div>`
    )
  }

  return {
    expressions,
    formattedExplanation: result.join('\n')
  }
}
